export const ru = {
    at: 'на',
    'at-percent': 'на {conversionInput} %',
    cancel: 'Отмена',
    down: 'уменьшить',
    max: 'макс',
    min: 'мин',
    'rate-string': '{change} ставку на {percent}%',
    save: 'Ок',
    up: 'увеличить'
};
